import Menu from "../../components/Common/Menu";
import Header from "../../components/Sections/Header";
import GradientContainer from "../../components/Sections/GradientContainer";
import Footer from "../../components/Common/Footer";
import header from "../../images/vectors/Surveillance-Systems-Header.svg";
import contact from "../../images/vectors/Surveillance-Systems-Contact.svg";
import ThreeColList from "../../components/Sections/ThreeLinkItems";
import ContactUs from "../../components/Sections/ContactUs";
import { hardware, software } from "../../utils/surveillanceSystems";

function SurveillanceSystems() {
  return (
    <div>
      <Menu />

      <Header
        title="Bringing intelligence"
        subTitle="to your doorstep"
        miniTitle="GBT Products"
        description="This partnership is more than distribution — it’s a new way of delivering technology. With GBT’s local expertise and TRASSIR’s smart surveillance solutions, businesses in the UAE gain access to future-ready security that learns, adapts, and evolves with every challenge."
        vector={header}
      />

      <GradientContainer
        className="h-[410px] md:h-[310px]"
        title="Smarter Surveillance with TRASSIR Cameras"
        content="TRASSIR cameras, powered by AI and delivered with GBT’s local expertise, give businesses in the UAE more than just video. With crystal-clear imaging, low-light performance, and built-in smart analytics like face recognition, motion detection, and crowd monitoring, they transform surveillance into actionable insights. Reliable, scalable, and future-ready — TRASSIR cameras help you protect assets and optimize operations at the same time."
        description="Uncover the smart choice for any security demand:"
      />
      <ThreeColList
        content={hardware.cameras}
        descriptionHeight="h-auto md:h-48"
      />

      <GradientContainer
        className="h-[410px] md:h-[310px]"
        title="TRASSIR NVRs Where every frame meets intelligence"
        content="TRASSIR NVRs go beyond simple storage — they deliver intelligent video management with smooth recording, instant playback, and powerful AI analytics support. Built to handle dozens to hundreds of cameras, they offer scalability, reliability, and efficiency, making them the backbone of modern surveillance in the UAE."
        description="Explore smarter solutions for every challenge:"
      />

      <ThreeColList content={hardware.nvr} descriptionHeight="h-auto md:h-48" />

      <GradientContainer
        className="h-[410px] md:h-[270px]"
        title="Turning video into vision"
        content="TRASSIR software transforms your surveillance system into an intelligent monitoring hub. From face recognition and crowd analysis to queue management and heat mapping, it turns every camera into a smart sensor, delivering actionable insights in real time. Scalable, flexible, and AI-powered, it helps businesses see more, react faster, and make smarter decisions."
        description="Find the perfect fit for your needs :"
      />

      <ThreeColList
        content={software.licenses}
        descriptionHeight="h-auto md:h-48"
      />

      <ContactUs
        title="Have questions about"
        subTitle="TRASSIR solutions?"
        description="We offer advanced IP cameras, NVR solutions, and intelligent video analytics for businesses of every scale. Our experts provide consultation, system design, and seamless implementation support. Contact us to explore tailored solutions that meet your security needs."
        vector={contact}
        subject="TRASSIR Surveillance Systems"
      />

      <Footer />
    </div>
  );
}
export default SurveillanceSystems;
